<template>
  <div id="app" class="app">
    <div class="bg" :style="`opacity: ${ activityData.bgFilterBlur ? 0.7 : 1 }; transform: scale(${ activityData.bgFilterBlur ? 1.1 : 1 }); filter: blur(${ activityData.bgFilterBlur === undefined ? 10 : activityData.bgFilterBlur }px); background: ${ activityData.themeColor || '#FF8235' } url('${ activityData.backgroundImage || 'https://yunyingcdn.thecover.cn/o_1gk5h77aueb01ppa1078nao1oo59.jpg' }'); background-size: 100% 100%;`" v-if="activityData"></div>
    <div class="main-view">
      <router-view :activityData="activityData" v-if="activityData" />
    </div>
    <base-component :baseData="baseData" :activityData="activityData" v-if="baseData"></base-component>
    <ToastComponent />
  </div>
</template>

<script>
import COVER from "../../utils/COVER";
import COVERAPP from "@/utils/COVERAPP";
import BaseComponent from "../../components/Base";
import ToastComponent from "../../components/Toast";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      activityData: null,
      baseData: null,
    };
  },
  created() {
    this.$aid = this.$route.query.id || "";
    const code = this.$route.query.code;
    const state = this.$route.query.state;
    // 如果是微信且已经是授权登录状态，则需先登录
    if ( COVERAPP.Attribute.isApp() || (COVERAPP.Attribute.isWeixin() && code && state.indexOf('COVER') < 0) ) {
      this.getUserinfo();
      return;
    }

    this.getActivityData();
  },
  components: {
    BaseComponent,
    ToastComponent,
  },
  methods: {
    ...mapActions(["setUserinfo", "setId"]),
    getUserinfo() {
      let _this = this;
      if (COVERAPP.Attribute.isApp()) {
        COVERAPP.Method.GetUser({
          callback(res) {
            let userinfo = JSON.parse(res);
            if (!COVER.isEmpty(userinfo.user_id)) {
              userinfo.origin = "app";
              if (COVERAPP.Attribute.isIOS()) {
                if (COVERAPP.Attribute.appVersion().split('.').join('') >= 450) {
                  try {
                    userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)))
                  }
                  catch(err) {
                    console.log(err);
                  }
                }
              }
              _this.setUserinfo(JSON.parse(JSON.stringify(userinfo)));
            }
            _this.getActivityData();
          },
        });
      } else {
        COVER.getUser((res) => {
          _this.setUserinfo(JSON.parse(JSON.stringify(res)));
          _this.getActivityData();
        });
      }
    },
    getActivityData() {
      COVER.$get("/activity/config", {
        aid: this.$aid,
      }).then((res) => {
        if (res.errno == 0) {
          let data = res.data;
          document.title = data.title;
          this.activityData = Object.assign(data.templateConfig, {
            title: data.title,
            isAppShow: data.isAppShow,
            serverTime: data.serverTime
          });
          this.baseData = Object.assign(
            {
              isAppShow: data.isAppShow,
              music: data.music,
              share: data.share,
              isEnd: data.serverTime >= new Date(data.endTime).getTime(),
            },
            data.openApp || {}
          );
        } else {
        }
      });
    },
  },
};
</script>

<style lang="less">
.bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.main-view {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  color: white;
}
.action {
  display: flex;
  margin-bottom: 3vw;
  .star {
    width: 100%;
    display: flex;
    height: 31vw;
    border-radius: 2vw;
    font-size: 6vw;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 2vw rgba(#000, .3);
    &:nth-child(2) {
      margin-left: 3vw;
    }
  }
  .rank {
    width: 100%;
    display: flex;
    height: 12vw;
    border-radius: 2vw;
    font-size: 4vw;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1vw 2vw rgba(#000, .3);
    img {
      width: 6vw;
      margin: 0 2vw;
      opacity: .8;
    }
    &:nth-child(2) {
      margin-left: 3vw;
    }
  }
}
</style>